import React, { Component, createRef } from 'react';
import { faPen, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import ValidationText from '../../utils/validation/ValidationText.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import Cheque from '../../components/cheque/Cheque.js';
import numBerToWord from 'number-to-words'

class ContraEntry extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            isGridView: true,
            isEditing: false,
            isChequePrint: false,
            daybookList: [],
            contraEntryList: [],
            isLoading: false,
            tableStatus: "",
            filterDetails: {
                search: "",
                arrangedBy: "",

            },
            contraDetails: {
                contraId: "",
                voucherNo: "",
                date: "",
                fromDaybookId: "",
                fromBankBalance: 0,
                toDayBookId: "",
                toBankBalance: 0,
                amount: 0,
                chqNo: "",
                narration1: "",
                narration2: "",
                toBankName: "",
                amountInWords: "",
            },
            arrangedByList: [
                { arrangedBy: "Voucher No.", value: "voucherNo" },
                { arrangedBy: "Date", value: "date" },
                { arrangedBy: "Amount.", value: "amount" },
            ],
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                fromDaybookId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "daybook(from transfer)"
                        ),
                    },
                ],
                toDayBookId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "daybook(to transfer)"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllContraEntry()
    }

    getAllContraEntry = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.accountServices.getAllContraEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ contraEntryList: response.responseData }, () => {
                    this.getAllDaybooks()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllDaybooks();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllDaybooks = () => {
        let request = ''
        this.commonServices.getAllDaybooks(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                const filteredBooks = response.responseData.filter(book => book.bookType === "Bank Book" || book.bookType === "Cash Book");
                let dropdownItems = filteredBooks.map((item) => ({
                    label: item.daybookName,
                    value: item._id,
                }));
                this.setState({ daybookList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    addEditContraEntry = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ isLoading: true }, () => {
                let request = this.state.contraDetails
                this.accountServices.addEditContraEntry(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.SwalServices.Success(response.Message);
                        let details = this.state.contraDetails
                        details.contraId = response.responseData._id
                        details.amountInWords = Number(details.amount) > 0 ?
                            numBerToWord.toWords(Number(details.amount)).replace(/,/g, '').replace(/\b\w/g, char => char.toUpperCase()) + ' Only' : '';
                        this.setState({ contraDetails: details, isLoading: false, isChequePrint: true })
                    } else {
                        this.SwalServices.Error(response.Message);
                        this.setState({ isLoading: false })
                    }
                });
            })
        }
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.contraDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false, isChequePrint: false });
    };
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}

        let filterDetails = this.state.filterDetails
        filterDetails.search = ""
        filterDetails.arrangedBy = ""

        let contraDetails = this.state.contraDetails
        contraDetails.contraId = ""
        contraDetails.date = ""
        contraDetails.voucherNo = ""
        contraDetails.fromDaybookId = ""
        contraDetails.toDayBookId = ""
        contraDetails.chqNo = ""
        contraDetails.amount = 0
        contraDetails.narration1 = ""
        contraDetails.narration2 = ""

        this.setState({ filterDetails: filterDetails, contraDetails: contraDetails, validState: validState, noItemFound: "" },
            () => {
                this.getAllContraEntry()
            }
        );
    }
    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllContraEntry()
            });
        }
        else if (section === "contraDetails") {
            let details = this.state.contraDetails;
            details[name] = value.toUpperCase();
            this.setState({ contraDetails: details });
        }
    };
    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => {
                this.getAllContraEntry()
            });
        }
        else if (section === "contraDetails") {
            let details = this.state.contraDetails;
            details[name] = select;
            this.setState({ contraDetails: details });
        }
    };

    getContraEntryVoucherNo = () => {
        this.accountServices.getContraEntryVoucherNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.contraDetails
                details.contraId = ''
                details.voucherNo = response.responseData.voucherNo
                details.date = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ contraDetails: details, isEditing: false }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.contraDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'toDayBookId') {
            details.toBankName = selected.label
            this.getBankBalanceByBankId(selected.value, 'toDayBookId')
        } else {
            this.getBankBalanceByBankId(selected.value, 'fromDaybookId')
        }
        this.setState({ contraDetails: details });
    };

    getBankBalanceByBankId = (id, fieldName) => {
        this.accountServices.getBankBalanceByBankId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.contraDetails
                if (fieldName === 'toDayBookId') {
                    details.toBankBalance = Number(response.responseData.closingBalance) ? Number(response.responseData.closingBalance).toFixed(2) : 0
                } else {
                    details.fromBankBalance = Number(response.responseData.closingBalance) ? Number(response.responseData.closingBalance).toFixed(2) : 0
                }
                this.setState({ contraDetails: details });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getContraEntryById = (id) => {
        this.accountServices.getContraEntryById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                // res.date = moment(res.date).format('yyyy-MM-DD')
                // res.amount = Number(res.amount).toFixed(2)
                // res.contraId = res._id
                // res.amountInWords = numBerToWord.toWords(res.amount).replace(/,/g, '').replace(/\b\w/g, char => char.toUpperCase()) + ' Only';
                // res.toBankName = this.state.daybookList.find(
                //     (party) => party.value === res.toDayBookId).label

                let details = this.state.contraDetails
                details.date = moment(res.date).format('yyyy-MM-DD')
                details.amount = Number(res.amount).toFixed(2)
                details.contraId = res._id
                details.amountInWords = Number(details.amount) > 0 ?
                    numBerToWord.toWords(Number(details.amount)).replace(/,/g, '').replace(/\b\w/g, char => char.toUpperCase()) + ' Only' : '';
                details.toBankName = this.state.daybookList.find(
                    (party) => party.value === res.toDayBookId).label
                details.voucherNo = res.voucherNo
                details.fromDaybookId = res.fromDaybookId
                details.fromBankBalance = res.fromBankBalance
                details.toDayBookId = res.toDayBookId
                details.toBankBalance = res.toBankBalance
                details.chqNo = res.chqNo
                details.narration1 = res.narration1
                details.narration2 = res.narration2

                this.setState({ contraDetails: details }, () => {
                    this.setState({ isGridView: false, isChequePrint: true, isEditing: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteContraEntryById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this Contra Entry ?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deleteContraEntryById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.SwalServices.Error(response.Message);
                        this.getAllContraEntry()
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    printCheque = () => {
        const printContent = this.printRef.current;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent.innerHTML;
        window.print();

        document.body.innerHTML = originalContent;
        window.location.reload();
    };

    render() {
        return (
            <div className='contraEntry-page'>

                {this.state.isGridView === true ? (
                    <>
                        {/* 1. Item Search  */}
                        <div className="item-search">
                            <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                                <div className="search-grp w-[60%]">
                                    <label>Voucher No.</label>
                                    <input
                                        type="text"
                                        id="search"
                                        name="search"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.filterDetails.search}
                                        onChange={(event) =>
                                            this.handleChange(event, "search", "filterDetails")
                                        }
                                    />
                                </div>

                                <div className="search-grp w-[40%]">
                                    <label>Arranged By</label>
                                    <select
                                        name="arrangedBy"
                                        className="w-full"
                                        value={this.state.filterDetails.arrangedBy && this.state.filterDetails.arrangedBy !== 'Select' && this.state.arrangedByList.find(
                                            (party) => party.value === this.state.filterDetails.arrangedBy
                                        ).value}
                                        onChange={(event) =>
                                            this.handleDropDownChange(
                                                event,
                                                "arrangedBy",
                                                "filterDetails"
                                            )
                                        }
                                    >
                                        <option>Select</option>
                                        {this.state.arrangedByList.map((x, key) => (
                                            <option key={key} value={x.value}>
                                                {x.arrangedBy}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            </div>
                            <button className="add-btn" onClick={() => this.getContraEntryVoucherNo()}>
                                Add New
                            </button>
                        </div>

                        {/* 2. Item tabel  */}
                        <div className="itemList-table">
                            <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[25%]'>Voucher No.</td>
                                            <td className='w-[25%]'>Date</td>
                                            <td className='w-[25%]'>Amount</td>
                                            <td className="w-[25%] !text-center" style={{ textAlign: "center" }}>Action</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.contraEntryList && this.state.contraEntryList.length > 0 ? (
                                            this.state.contraEntryList.map((item, key) => (
                                                <tr key={key}>
                                                    <td>{item.voucherNo}</td>
                                                    <td>{moment(item.date).format('DD MMM yyyy')}</td>
                                                    <td>{Number(item.amount).toFixed(2)}</td>
                                                    <td className='!text-center'>
                                                        <button
                                                            className="search-btn"
                                                            onClick={() => this.getContraEntryById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            onClick={() => this.deleteContraEntryById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : this.state.contraEntryList
                                            && this.state.contraEntryList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.contraEntryList
                                            && this.state.contraEntryList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                ) : null}
                {this.state.isGridView === false ? (
                    <>
                        <div className="item-form mb-[18px]">
                            <div className="item-grp flex gap-2.5 mb-3 w-[60%]">
                                <div className="input-grp w-full">
                                    <label>Voucher No</label>
                                    <input
                                        type="text"
                                        id="voucherNo"
                                        name="voucherNo"
                                        className="inputFocus"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.contraDetails.voucherNo}
                                        onChange={(event) =>
                                            this.handleChange(event, "voucherNo", "contraDetails")
                                        }
                                    />

                                </div>
                                <div className="input-grp w-full">
                                    <label>Date</label>
                                    <input
                                        type="date"
                                        id="date"
                                        name="date"
                                        className={`inputFocus ${this.state.validState?.error?.date ? "errorInput" : ""}`}
                                        autocomplete="off"
                                        value={this.state.contraDetails.date}
                                        onChange={(event) =>
                                            this.handleChange(event, "date", "contraDetails")
                                        }
                                    />
                                    {/* <ValidationText error={this.state.validState.error.date} /> */}
                                </div>
                            </div>

                            <div className='flex gap-2.5 w-[60%] mb-3'>
                                <div className="input-grp w-full">
                                    <label>From</label>
                                    <MultiSelectDropdown
                                        drpIdentity="fromDaybookId"
                                        options={this.state.daybookList}
                                        className={` ${this.state.validState?.error?.fromDaybookId ? "errorInput" : ""}`}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            this.setFilterParameters(selected, "fromDaybookId")
                                        }
                                        allowSelectAll={false}
                                        value={this.state.daybookList.filter(
                                            (party) =>
                                                party.value === this.state.contraDetails.fromDaybookId
                                        )}
                                    />
                                    {/* <ValidationText error={this.state.validState.error.fromDaybookId} /> */}
                                </div>
                                <div className="min-w-[40%]">
                                    <label>Balance</label>
                                    <input
                                        type="number"
                                        id="fromBankBalance"
                                        name="fromBankBalance"
                                        className="inputFocus"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.contraDetails.fromBankBalance}
                                        onChange={(event) =>
                                            this.handleChange(event, "fromBankBalance", "contraDetails")
                                        }
                                    />

                                </div>
                            </div>
                            <div className='flex gap-2.5 w-[60%] mb-3'>

                                <div className="input-grp w-full">
                                    <label>To</label>
                                    <MultiSelectDropdown
                                        drpIdentity="toDayBookId"
                                        options={this.state.daybookList}
                                        className={` ${this.state.validState?.error?.toDayBookId ? "errorInput" : ""}`}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            this.setFilterParameters(selected, "toDayBookId")
                                        }
                                        allowSelectAll={false}
                                        value={this.state.daybookList.filter(
                                            (party) =>
                                                party.value === this.state.contraDetails.toDayBookId
                                        )}
                                    />
                                    {/* <ValidationText error={this.state.validState.error.toDayBookId} /> */}
                                </div>
                                <div className="min-w-[40%]">
                                    <label>Balance</label>
                                    <input
                                        type="number"
                                        id="toBankBalance"
                                        name="toBankBalance"
                                        className="inputFocus"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.contraDetails.toBankBalance}
                                        onChange={(event) =>
                                            this.handleChange(event, "toBankBalance", "contraDetails")
                                        }
                                    />

                                </div>
                            </div>

                            <div className="item-grp flex gap-2.5 mb-3 w-[60%] ">
                                <div className="input-grp w-full">
                                    <label>Amount</label>
                                    <input
                                        type="number"
                                        id="amount"
                                        name="amount"
                                        className={`inputFocus ${this.state.validState?.error?.amount ? "errorInput" : ""}`}
                                        autocomplete="off"
                                        value={this.state.contraDetails.amount}
                                        onChange={(event) =>
                                            this.handleChange(event, "amount", "contraDetails")
                                        }
                                    />
                                    {/* <ValidationText error={this.state.validState.error.amount} /> */}
                                </div>
                                <div className="input-grp w-full">
                                    <label>Cheque No.</label>
                                    <input
                                        type="number"
                                        id="chqNo"
                                        name="chqNo"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.contraDetails.chqNo}
                                        onChange={(event) =>
                                            this.handleChange(event, "chqNo", "contraDetails")
                                        }
                                    />
                                </div>
                            </div>

                            <div className="input-grp w-[60%] mb-3">
                                <label>Narration</label>
                                <input
                                    type="text"
                                    id="narration1"
                                    name="narration1"
                                    className="inputFocus"
                                    autocomplete="off"
                                    value={this.state.contraDetails.narration1}
                                    onChange={(event) =>
                                        this.handleChange(event, "narration1", "contraDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-[60%]">
                                <label>Narration</label>
                                <input
                                    type="text"
                                    id="narration2"
                                    name="narration2"
                                    className="inputFocus"
                                    autocomplete="off"
                                    value={this.state.contraDetails.narration2}
                                    onChange={(event) =>
                                        this.handleChange(event, "narration2", "contraDetails")
                                    }
                                />
                            </div>
                        </div>
                        <div className="btn-grp">
                            {this.state.isEditing === true ? (
                                <button
                                    className="add-btn"
                                    disabled={this.state.isLoading}
                                    onClick={() => this.addEditContraEntry()}
                                >
                                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                                </button>
                            ) : (
                                <button
                                    className="add-btn"
                                    disabled={this.state.isLoading}
                                    onClick={() => this.addEditContraEntry()}
                                >
                                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                                </button>
                            )}
                            <button className="cancel-btn" onClick={() => this.openGridView()} disabled={this.state.isLoading}>Cancel</button>
                            {this.state.isChequePrint ?
                                <button className="print-btn" onClick={() => this.printCheque()} disabled={this.state.isLoading}>Cheque Print</button>
                                : null}
                        </div>
                    </>
                ) : null}

                <div
                    ref={this.printRef}
                    className='hidden print:block'
                >
                    <Cheque
                        amount={this.state.contraDetails.amount}
                        amountInWords={this.state.contraDetails.amountInWords}
                        date={moment(this.state.contraDetails.date).format('DD MM YYYY')}
                        partyName={this.state.contraDetails.toBankName}
                        accountType='A/C Payee Only'
                    />
                </div>
            </div>
        );
    }
}

export default ContraEntry;